module.exports = __webpack_public_path__ + "img/legend-sy.a01ab18a.png";